import { ref, watch, computed } from 'vue';
import { genFileId } from 'element-plus';
import { BASE_URL } from "@/services/request/config";
export default {
  props: {
    imgData: {
      type: Array,
      default: () => []
    },
    limitNum: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    deleteDisabled: {
      type: Boolean,
      default: false
    },
    uploadType: {
      type: String,
      default: 'picture-card'
    }
  },

  setup(props, {
    emit
  }) {
    const fileList = computed(() => props.imgData);
    const limit = computed(() => props.limitNum);
    const listType = computed(() => props.uploadType);
    const imgDisabled = computed(() => props.disabled);
    const uploadFile = ref([]); // 成功上传图片数据

    const dialogImageUrl = ref('');
    const dialogVisible = ref(false);
    const upload = ref(null);
    const api = computed(() => {
      if (props.uploadType === 'picture-card') {
        return BASE_URL + '/file/uploads';
      } else {
        return BASE_URL + '/file/import';
      }
    }); // 移除文件

    const handleRemove = (file, uploadFiles) => {
      uploadFile.value = [];
      uploadFiles.forEach(item => {
        if (props.uploadType === 'picture-card') {
          uploadFile.value.push(item.response.data[0].path);
        } else {
          uploadFile.value.push(item.response.data);
        }
      });
    }; // 文件数超出限制时事件方法


    const handleExceed = files => {
      upload.value.clearFiles();
      const file = files[0];
      file.uid = genFileId();
      upload.value.handleStart(file);
      upload.value.submit();
    }; // 预览图片文件


    const handlePictureCardPreview = uploadFile => {
      dialogImageUrl.value = uploadFile.url;
      dialogVisible.value = true;
    }; // 成功上传回调钩子


    const uploadSuccess = response => {
      if (response.code === 200) {
        if (props.uploadType === 'picture-card') {
          uploadFile.value.push(response.data[0].path);
        } else {
          uploadFile.value.push(response.data);
        }
      }
    };

    watch(() => uploadFile.value, newVal => {
      if (props.uploadType === 'picture-card') {
        let data = [];

        if (fileList.value.length >= 1) {
          data = fileList.value.map(item => item.url.slice(item.url.indexOf('uploadt') - 1));
        }

        emit('getSuccessUploadImg', data.concat(newVal));
      } else {
        emit('getImportFileData', newVal?.[0]);
      }
    }, {
      deep: true
    });
    return {
      fileList,
      dialogImageUrl,
      dialogVisible,
      handleRemove,
      handlePictureCardPreview,
      api,
      uploadSuccess,
      imgDisabled,
      handleExceed,
      upload,
      listType,
      limit,
      uploadFile
    };
  }

};